import { defineStore } from 'pinia'

export const useUnsavedChangesStore = defineStore('unsavedChanges', {
  state: () => ({
    dirtySources: {},
    pendingRoute: null,
    showDialog: false,
    allowNavigation: false,
  }),

  getters: {
    isDirty: (state) => Object.keys(state.dirtySources).length > 0,
  },

  actions: {
    setDirty(key, value) {
      if (!key) return
      if (value) {
        this.dirtySources = { ...this.dirtySources, [key]: true }
        return
      }
      if (this.dirtySources[key]) {
        const next = { ...this.dirtySources }
        delete next[key]
        this.dirtySources = next
      }
    },

    clearAll() {
      this.dirtySources = {}
    },

    requestNavigation(route) {
      this.pendingRoute = route
      this.showDialog = true
    },

    cancelNavigation() {
      this.pendingRoute = null
      this.showDialog = false
    },

    confirmNavigation() {
      const target = this.pendingRoute
      this.pendingRoute = null
      this.showDialog = false
      this.allowNavigation = true
      return target
    },
  },
})
